import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "@/i18n/en-us/translation.json";
import hant from "@/i18n/zh-hant/translation.json";
import hans from "@/i18n/zh-hans/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    "en-us": { translation: en },
    "zh-hant": { translation: hant },
    "zh-hans": { translation: hans },
  },
  fallbackLng: "zh-hant",
  supportedLngs: ["en-us", "zh-hant", "zh-hans"],

  lowerCaseLng: true,
  load: "currentOnly",
  nonExplicitSupportedLngs: false,

  interpolation: { escapeValue: false },
});

export default i18n;
